import React from 'react';
import { CircularProgress, useMediaQuery } from '@mui/material';
import { Box, Modal as ECModal } from '@eatclubapp/ec-component-library';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { PrimaryButton } from '../button/PrimaryButton';
import { RoundButton } from '../button/RoundButton';
import { modalInputStyle, modalStyle } from './ModalStyles';

/**
 * New look modal used to show features with a more obvious CTA
 */
export const FeatureModal = ({
  cancelLabel = 'Cancel',
  children,
  confirmLabel = 'Confirm',
  disabled = false,
  heading,
  headingStartIcon = null,
  isLoading = false,
  isOpen,
  onCancel = () => {},
  onClose = () => {},
  onConfirm = () => {},
  style = {},
  inputStyle = {},
  hideFooter = false,
  hideCancelButton = false,
}) => {
  const muiTheme = useTheme();
  const breakpointSmDown = useMediaQuery(muiTheme.breakpoints.down('sm'));

  return (
    <ECModal
      fullWidth={false}
      inputStyle={{ ...modalInputStyle, ...inputStyle }}
      isOpen={isOpen}
      onClose={onClose}
      showCloseText={false}
      style={modalStyle(breakpointSmDown, style)}
    >
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        {heading && (
          <Box
            style={{
              alignItems: 'center',
              display: 'flex',
              gap: '8px',
              marginBottom: '32px',
              ...style?.heading,
            }}
          >
            {headingStartIcon}

            <Box style={{ fontSize: '40px', lineHeight: '40px' }}>{heading}</Box>
          </Box>
        )}

        <Box>{children}</Box>

        {hideFooter ? null : (
          <Box
            style={{
              display: 'flex',
              width: '100%',
              gap: '20px',
              justifyContent: hideCancelButton ? 'center' : 'space-between',
              paddingTop: '28px',
            }}
          >
            {hideCancelButton ? null : (
              <RoundButton
                onClick={() => {
                  onCancel();
                  onClose();
                }}
                fullWidth={breakpointSmDown}
                color='secondary'
                variant='outlined'
                size='large'
                disabled={isLoading}
                style={{
                  button: {
                    height: '48px',
                    fontWeight: '500',
                    border: `1px solid #DCDCDB`,
                  },
                }}
              >
                {cancelLabel}
              </RoundButton>
            )}

            <PrimaryButton
              onClick={onConfirm}
              fullWidth={breakpointSmDown}
              color='secondary'
              variant='contained'
              size='large'
              disabled={isLoading || disabled}
              style={{ button: { height: '48px', fontWeight: '500' } }}
            >
              {isLoading ? <CircularProgress color='inherit' size={24} /> : confirmLabel}
            </PrimaryButton>
          </Box>
        )}
      </Box>
    </ECModal>
  );
};

FeatureModal.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  heading: PropTypes.string,
  headingStartIcon: PropTypes.node,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  style: PropTypes.shape({}),
  inputStyle: PropTypes.shape({}),
  hideFooter: PropTypes.bool,
};
